// Core
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// Styles
import './styles.scss';

// images
import { restAPIs } from 'utils/restAPIs';
import { fetchData } from 'utils/fetch';
import { useDispatch, useSelector } from 'react-redux';
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"
import ViewItem from './ViewItem';
import { Skeleton } from '@mui/material';

const Portfolio = () => {
    const { portfolio, currentLang, portfolioItem } = useSelector((store) => store.commonData);
    const { t } = useTranslation();
    const [isLastPage, setIsLastPage] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [isLoadingPage, setLoadingPage] = useState(false);
    const [page, setPage] = useState(1);
    const [showModel, setShowModel] = useState(false)
    const dispatch = useDispatch();

    const fetchPortfolio = async () => {

        setLoading(true)
        const res = await fetchData(restAPIs.getPortfolio(currentLang?.id, 1));
        setLoading(false)
        dispatch({
            type: 'portfolio',
            value: res.items
        });
        setIsLastPage(res.isLastPage)
    }

    useEffect(() => {
        dispatch({
            type: 'portfolio',
            value: []
        });
        fetchPortfolio();
    }, [currentLang]);

    const handlePageClick = () => {
        let curren = page
        setPage(curren + 1);
        fetchPaginate(curren + 1)
    }

    const fetchPaginate = async (page = 1) => {
        setLoadingPage(true)
        const res = await fetchData(restAPIs.getPortfolio(currentLang?.id, page));
        setLoadingPage(false)
        dispatch({
            type: 'portfolio',
            value: portfolio.concat(res.items)
        });
        setIsLastPage(res.isLastPage)
    }

    const handleCloseModel = () => {
        setShowModel(false)
    }

    const handleOpenModel = (item) => {
        dispatch({
            type: 'portfolioItem',
            value: item
        });
        setShowModel(true)
    }


    return (
        <>
            <div className='container mt-5'>
                <div className='row justify-content-center'>
                    <div className='col-md-6'>
                        <h6 className='mb-4'>Cultural Heritage</h6>
                        <h3 className='mb-4'>Exclusive Collection done for "Emirati Arts Exhibition", Khawla Art Gallery Dubai</h3>
                    </div>
                </div>
            </div>
            <div className='container mb-4 mt-4'>
                <div className='row justify-content-center'>
                    <div className='__container'>
                    
                        {isLoading ?
                            <ResponsiveMasonry columnsCountBreakPoints={{ 350: 2 }} >
                                <Masonry gutter='20px'>
                                    {[...Array(3)].map((item, idx) => {
                                        return (
                                            <Skeleton variant="rounded" width="99%" height={270} style={{ borderRadius: '27px' }} />
                                        )
                                    })}
                                </Masonry>
                            </ResponsiveMasonry>

                            :
                            <ResponsiveMasonry columnsCountBreakPoints={{ 350: 2 }} >
                                <Masonry gutter='20px'>
                                    {portfolio?.map((item, idx) => {
                                        return (
                                            <figure key={idx}>
                                                <img src={item.artPicture} alt="" width="100%" />
                                                <a onClick={() => handleOpenModel(item)}>{item.artTitle}</a>
                                            </figure>
                                        )
                                    })
                                    }
                                </Masonry>
                            </ResponsiveMasonry>
                        }
                    </div>
                    {isLoading ? '' :
                        <div className='__pagination' style={{ justifyContent: 'center' }}>
                            {isLastPage ? '' : <button onClick={handlePageClick} className='_hand_btn'>{t('more')} </button>}
                        </div>
                    }
                    <ViewItem
                        open={showModel}
                        onClose={handleCloseModel}
                        title={portfolioItem}
                    />
                </div>
            </div>
        </>
    );
};

export default Portfolio;
